module.exports = __webpack_public_path__ + "img/no-family.4be534a7.png";